import { randomIdentifier } from '@texas/utils/helpers/commonHelpers';
import { SearchQuery, EntityItem } from '../../../types';
import { dimensionGroupsApi } from '@texas/api/endpoints/metadata/dimensionGroupsApi';
import { ChatMessageEntityLinkType } from '@texas/api/endpoints/chat/chatApi';

export async function searchDimensionGroup(
  query: SearchQuery,
): Promise<EntityItem[]> {
  const response = await dimensionGroupsApi.search({
    searchTerm: query.query,
    sortBy: '',
    sortDesc: false,
    includeArchived: false,
  });

  if (response.hasError) {
    return [];
  }

  return response.data.map((c) => ({
    id: c.id,
    name: c.name,
    type: ChatMessageEntityLinkType.DimensionGroup,
    identifier: randomIdentifier(),
  }));
}
